import DataSkDiagnosa from "@/services/DataSkDiagnosa";
import { storeSoap } from "@/store/modules/soap";
import { userModule } from "@/store/modules/user";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";

export interface SkDiagnosaState {
  skDiagnosa: Diagnosa[];
  detailSkDiagnosa: Diagnosa;
}

interface Diagnosa {
  id: number;
  register_id: number;
  pasien_rm: string;
  diagnosis: any;
  tindak_lanjut: any;
  klinik_tujuan: any;
  signed: number;
  dokter: object;
  unit: object;
  signature: Array<object>;
}

@Module({ store, dynamic: true, namespaced: true, name: "storeSkDiagnosa" })
class SkDiagnosaStore extends VuexModule implements SkDiagnosaState {
  detailSkDiagnosa = {} as Diagnosa;
  skDiagnosa: Diagnosa[] = [];
  loading = false;

  @Mutation SET_SK_DIAGNOSA(skDiagnosa: Diagnosa[]) {
    this.skDiagnosa = skDiagnosa;
  }

  @Mutation SET_DETAIL_SK_DIAGNOSA(detailSkDiagnosa: Diagnosa) {
    this.detailSkDiagnosa = detailSkDiagnosa;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action actSKD_on_reg(reg) {
    this.SET_LOADING(true);

    DataSkDiagnosa.getDataSkDiagnosa(reg)
      .then(dt => {
        const data = dt.data;

        this.SET_SK_DIAGNOSA(data);
      })
      .finally(() => {
        this.SET_LOADING(false);
      });
  }

  @Action actSKD_on_new() {
    // const dt = DataSkDiagnosa.getDataSkDiagnosabyID(1);
    // dt.then(dt => {
    //   const detail = dt.data

    const detail = {
      id: null,
      register_id: null,
      pasien_rm: "",
      diagnosis: storeSoap.detailSoap[0].a,
      tindak_lanjut: null,
      klinik_tujuan: null,
      signed: null,
      dokter: { id: userModule.user.id, nama: userModule.user.nama },
      unit: { id: "", nama: "" },
      signature: []
    };
    this.SET_DETAIL_SK_DIAGNOSA(detail);
    // });
  }

  @Action actSKD_on_id(id) {
    // alert(id)
    // console.log('vuex')
    const dt = DataSkDiagnosa.getDataSkDiagnosabyID(id);
    dt.then(dt => {
      const detail = dt.data;
      // const detail = { id: 16, register_id: 20067915, nomor: "445/R/000019", dpjp_id: 428, unit_id: "08", tgl_rujukan: "2021-03-20", diagnosis: "assperasdasda", alasan: "masih pusing ya", rtl: "kontrol", tgl_kunjungan: "2021-03-25", user_id: 428, signed: 0, dokter: { id: 428, nama: "dr. I NYOMAN TRITIA WIDIANTARA, Sp. OG" }, unit: { id: "08", nama: "Klinik Kebidanan" }, signature: [] }
      this.SET_DETAIL_SK_DIAGNOSA(detail);
    });
  }
}

export const storeSkDiagnosa = getModule(SkDiagnosaStore);
